import { render } from "./CardGroup.vue?vue&type=template&id=4460b5b0&scoped=true"
import script from "./CardGroup.vue?vue&type=script&lang=js"
export * from "./CardGroup.vue?vue&type=script&lang=js"

import "./CardGroup.vue?vue&type=style&index=0&id=4460b5b0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4460b5b0"]])

export default __exports__